import { Stack, Typography } from "@mui/material";
import React from "react";

export const calendarDescriptionId = (fieldId: string) =>
  `${fieldId}-description`;

interface CalendarFieldLabelProps {
  fieldId: string;
  label: string;
  help: string;
}

const CalendarFieldLabel: React.FC<CalendarFieldLabelProps> = ({
  fieldId,
  label,
  help,
}) => {
  const descriptionId = calendarDescriptionId(fieldId);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography component="span">{label}</Typography>
      <span
        id={descriptionId}
        style={{
          position: "absolute",
          width: 1,
          height: 1,
          overflow: "hidden",
          clip: "rect(0 0 0 0)",
        }}
      >
        {help}
      </span>
    </Stack>
  );
};

export default CalendarFieldLabel;